import styled, { css } from 'styled-components';

export const Timer = styled.div`
  ${({ theme: { spacing, color, borderRadius, fontSize } }) => css`
    min-width: 110px;
    font-family: Ubuntu, sans-serif;
    font-size: ${fontSize.xxl};
    padding: ${spacing.p1} ${spacing.p1};
    color: ${color.midnight5};
    background-color: ${color.white};
    letter-spacing: 1px;
    border: 1px solid ${color.blue30};
    border-radius: ${borderRadius.sm};
    display: inline-block;
    text-align: center;
  `}
`;
